import React, { useEffect } from "react";
import { SectionUnlockingSwitch } from "features/AdminPanel/modules/SectionUnlockingSwitch/SectionUnlockingSwitch";
import { useFeaturesStore } from "../../store/useFeaturesStore";
import { useAdminPanelStore } from "features/AdminPanel/store/useAdminPanelStore";
import {
  GRACE_PERIOD_KEYS,
  GRACE_PERIOD_MODAL_STORE_KEYS,
} from "../../constants/Features.constants";
import { GRACE_PEROID_VALIDATION_CONSTANTS } from "features/ManageOfferings/modules/Subscriptions/constants/Subscriptions.constants";
import { SubscriptionGracePeriodDaysInput } from "../SubscriptionGracePeriodDaysInput/SubscriptionGracePeriodDaysInput";

export const SubscriptionGradePeriodToggle = ({ subSectionKey }) => {
  const sectionConfig = useAdminPanelStore((state) => state.sectionConfig);
  const subSectionConfig = sectionConfig[subSectionKey] || {};
  const { value } = subSectionConfig;
  const { isGracePeriod, handleStoreValChange, handleOpen } =
    useFeaturesStore();

  const handleToggleChange = () => {
    handleStoreValChange(
      GRACE_PERIOD_MODAL_STORE_KEYS.isGracePeriod,
      !isGracePeriod
    );
    handleStoreValChange(
      GRACE_PERIOD_MODAL_STORE_KEYS.gracePeriodDays,
      !isGracePeriod ? GRACE_PEROID_VALIDATION_CONSTANTS.DEFAULT : null
    );
    handleStoreValChange(GRACE_PERIOD_MODAL_STORE_KEYS.isToggled, true);
    handleOpen();
  };

  useEffect(() => {
    if (value) {
      handleStoreValChange(
        GRACE_PERIOD_MODAL_STORE_KEYS.isGracePeriod,
        value[GRACE_PERIOD_KEYS.SUBSCRIPTION_GRACE_PERIOD] ? true : false
      );
      handleStoreValChange(
        GRACE_PERIOD_MODAL_STORE_KEYS.gracePeriodDays,
        value[GRACE_PERIOD_KEYS.SUBSCRIPTION_GRACE_PERIOD]
      );
    }
  }, []);

  return (
    <div className="tw-flex tw-items-center">
      <SectionUnlockingSwitch
        value={isGracePeriod}
        onChange={handleToggleChange}
      />
      {isGracePeriod && (
        <span className="tw-flex tw-justify-center tw-items-center">
          <SubscriptionGracePeriodDaysInput isDebounce />
        </span>
      )}
    </div>
  );
};
